import { render, staticRenderFns } from "./RulesCreate.vue?vue&type=template&id=37b89c46"
import script from "./RulesCreate.vue?vue&type=script&lang=js"
export * from "./RulesCreate.vue?vue&type=script&lang=js"
import style0 from "./RulesCreate.vue?vue&type=style&index=0&id=37b89c46&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports